// @flow

import styled from "styled-components";
import { fontNormal } from "@fdr/static-ui/Typography";
import buildColor from "@fdr/static-ui/ColorPalette";

const Label = styled.div`
  font-weight: 500;
  font-size: 14px;
  font-family: ${fontNormal};
  color: ${buildColor("grey", "D3")};
`;

export default Label;
